import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PaintBrush"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.6229 17.3775L17.2504 12.9975V9.75002C17.2516 9.55066 17.1733 9.35905 17.0329 9.21751L9.53294 1.71752C9.39212 1.57553 9.20042 1.49567 9.00044 1.49567C8.80046 1.49567 8.60877 1.57553 8.46794 1.71752L1.71794 8.46751C1.57596 8.60834 1.49609 8.80004 1.49609 9.00002C1.49609 9.19999 1.57596 9.39169 1.71794 9.53252L9.21794 17.0325C9.35948 17.1729 9.55109 17.2512 9.75044 17.25H13.0054L17.3779 21.63C18.5502 22.8022 20.4507 22.8022 21.6229 21.63C22.7952 20.4578 22.7952 18.5572 21.6229 17.385V17.3775ZM4.50039 7.80752L6.21789 9.53252L7.28289 8.46752L5.55789 6.75002L6.75039 5.55752L9.96789 8.78252L11.0329 7.71752L7.80789 4.50002L9.00039 3.30752L13.9429 8.25002L8.25039 13.9425L3.30789 9.00002L4.50039 7.80752ZM20.5579 20.5575C19.9728 21.1391 19.0279 21.1391 18.4429 20.5575L13.8454 15.9675C13.6856 15.8576 13.504 15.7834 13.3129 15.75H10.0579L9.30789 15L15.0004 9.30752L15.7504 10.0575V13.3125C15.7512 13.5093 15.8293 13.6978 15.9679 13.8375L20.5579 18.4425C21.1395 19.0276 21.1395 19.9725 20.5579 20.5575Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PaintBrush.vue"]]);
